import glamorous from 'glamorous';

const GridItem = glamorous.div(
  ({ disabled }) => ({
    opacity: disabled ? 0.5 : 1,
    backgroundColor: 'white',
    borderRadius: 8,
    overflow: 'hidden',
  }),
  ({ big, expanded }) =>
    (big
      ? {
        gridColumn: expanded ? '1 / -1' : 'auto / span 2',
        gridRow: expanded ? 'auto / span 2' : 'auto',
      }
      : {}),
);

export default GridItem;
